import { create } from 'zustand';

// Theme store
export const useThemeStore = create((set) => ({
  theme: localStorage.getItem('pharmax_theme') || 'dark',
  setTheme: (theme) => {
    localStorage.setItem('pharmax_theme', theme);
    if (theme === 'dark') {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
    set({ theme });
  },
  toggleTheme: () => {
    const current = localStorage.getItem('pharmax_theme') || 'dark';
    const next = current === 'dark' ? 'light' : 'dark';
    localStorage.setItem('pharmax_theme', next);
    if (next === 'dark') {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
    set({ theme: next });
  },
}));

// Right panel store
export const useRightPanelStore = create((set) => ({
  isOpen: false,
  activeTab: 'artifacts',
  open: (tab = 'artifacts') => set({ isOpen: true, activeTab: tab }),
  close: () => set({ isOpen: false }),
  setTab: (tab) => set({ activeTab: tab }),
  toggle: () => set((s) => ({ isOpen: !s.isOpen })),
}));

// Sidebar store
export const useSidebarStore = create((set) => ({
  collapsed: false,
  mobileOpen: false,
  toggle: () => set((s) => ({ collapsed: !s.collapsed })),
  setCollapsed: (collapsed) => set({ collapsed }),
  openMobile: () => set({ mobileOpen: true }),
  closeMobile: () => set({ mobileOpen: false }),
  toggleMobile: () => set((s) => ({ mobileOpen: !s.mobileOpen })),
}));

// Project workspace store
export const useWorkspaceStore = create((set) => ({
  currentProject: null,
  currentSession: null,
  currentDataset: null,
  messages: [],
  artifacts: [],
  reportBlocks: [],
  isLoading: false,
  setProject: (project) => set({ currentProject: project }),
  setSession: (session) => set({ currentSession: session }),
  setDataset: (dataset) => set({ currentDataset: dataset }),
  setMessages: (messages) => set({ messages }),
  addMessage: (msg) => set((s) => ({ messages: [...s.messages, msg] })),
  setArtifacts: (artifacts) => set({ artifacts }),
  addArtifact: (artifact) => set((s) => ({ artifacts: [artifact, ...s.artifacts] })),
  setReportBlocks: (blocks) => set({ reportBlocks: blocks }),
  addReportBlock: (block) => set((s) => ({ reportBlocks: [...s.reportBlocks, block] })),
  removeReportBlock: (id) => set((s) => ({ reportBlocks: s.reportBlocks.filter(b => b.id !== id) })),
  reorderReportBlocks: (blocks) => set({ reportBlocks: blocks }),
  setLoading: (loading) => set({ isLoading: loading }),
}));
